//巡检报告 相关请求
import req from './index'

//获取巡检报告数据
export const getInspectionReportFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.InsReportList_Get', params)
}

//获取巡检报告
export const getReportFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.InsReportCreate_Get', params)
}
